import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Item from './item';

const ProductCarousel = props => {
   const { products = [] } = props;
   const settings = {
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 4,
      cssEase: 'linear',
      responsive: [
         {
            breakpoint: 1024,
            settings: {
               slidesToShow: 2,
               slidesToScroll: 2,
            },
         },
         {
            breakpoint: 767,
            settings: {
               slidesToShow: 1,
               slidesToScroll: 1,
            },
         },
      ],
   };
   return (
      <Slider {...settings}>
         {products.map((product, index) => (
            <Item key={index} item={product} />
         ))}
      </Slider>
   );
};

export default ProductCarousel;



// WEBPACK FOOTER //
// ./src/components/Products/product-carrousel.js